import { render, staticRenderFns } from "./OrgObjectHeader.vue?vue&type=template&id=96ae60a6"
import script from "./OrgObjectHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./OrgObjectHeader.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OrgObjectHeader.vue?vue&type=style&index=0&id=96ae60a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports